<template>
  <div id="tags" ref="tags" :class="[elClassProp, {'no-tags': !tags.length}]">
    <div class="tags-wrapper">
      <template v-for="(tag, indx) in tags" :key="indx">
        <el-tooltip
          :disabled="(tag.value && normalTagMaxCharLength >= parseInt(tag.value.length))"
          :popper-class="'custom-tooltip-popper-tag'"
          :show-arrow="false"
          effect="light"
          :content="(tag.showLabel) ? tag.showLabel : tag.value"
          placement="bottom"
          class="item">
            <el-tag :key="indx"
              :disable-transitions="true"
              :style="{'backgroundColor': (tag.backgroundColor ? tag.backgroundColor: ''), 'color': (tag.textColor ? tag.textColor: '')}"
              :class="{'selected': (selectedTagItem.index === indx), 'config-tag': tag.configTag && !tag.ledDimensionTag, 'hide-by-tag-user-rights': tag.hideByTagUserRights}">
              <template v-if="!tag.hideByTagUserRights">
                <div @click="handleTagItemClick(tag, indx)" class="tag-val">
                  <span v-if="tag.showLabel">{{tag.showLabel}}</span>
                  <span v-else>{{tag.value}}</span>
                </div>
                <div class="edit-tag-val">
                  <el-input
                    id="tags-edit-input"
                    :model-value="tags[indx].value"
                    @update:model-value="newValue => tags[indx].value = newValue"
                    :ref="`idTagInput-${indx}`"
                    class="input-edit-tag"
                    @input="handleInputTag($event, indx, 'edit')"
                    @blur="handleInputConfirm({ type: 'edit', tagIndx: indx})">
                  </el-input>
                </div>
                <i v-if="enableDeleteTags && disabledEditTagItems.indexOf(tag.value) < 0" @click="handleRemoveIconClick(indx, tag.value)" class="el-tag__close el-icon-close"></i>
              </template>
            </el-tag>
        </el-tooltip>
      </template>

      <div v-if="enableCreateTags && tags.length < maxNewTag" :class="['new-tag-wrapper',
        {'auto-height': (forceToHideNewButton)}]">
        <template v-if="isNewInputTagVisible">
          <template v-if="addNewTagAsDropdown">
            <el-select
              :model-value="inputValue"
              @update:model-value="newValue => inputValue = newValue"
              @change="handleInputEvent($event, 'onSelect')"
              popper-class="add-new-tag-as-dropdown"
              class="cstm-selectbox-grey">
              <el-option v-for="(item, indx) in newTagOptions" :key="indx" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </template>
          <template v-else>
            <el-autocomplete
              id="tags-add-input"
              :model-value="inputValue"
              @update:model-value="newValue => inputValue = newValue"
              ref="saveTagInput"
              :popper-class="'custom-tags-auto-complete-dropdown'"
              :fetch-suggestions="querySearch"
              @input="handleInputTag($event, (tags.length + 1), 'create')"
              @select="handleInputEvent($event, 'suggestionSelect')">
              <template #default="{ item }">
                <!-- Apply background color with hex alpha value of 99 (equivalent to alpha value 0.6 applied when tag is selected) -->
                <div class="value" :style="{'backgroundColor': `${item.backgroundColor}99`}">{{ item.value }}</div>
              </template>
            </el-autocomplete>
          </template>
        </template>

        <el-button v-if="!isNewInputTagVisible && !forceToHideNewButton" @click.stop="handleShowNewTagInput" :class="['new-tagb-btn', {'has-tags': tags.length}]"></el-button>
      </div>
    </div>
  </div>
</template>

<script src="./tags.js"></script>
<style lang="scss" src="./tags.scss"></style>
